var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgPhoneCheck = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 40,
  height: 40,
  fill: "none"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 40,
  height: 40,
  fill: "#EBEFFE",
  rx: 12
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#phone-check_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#223B90",
  d: "M27 9H17c-1.1 0-2 .9-2 2v2c0 .55.45 1 1 1s1-.45 1-1v-1h10v16H17v-1c0-.55-.45-1-1-1s-1 .45-1 1v2c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V11c0-1.1-.9-2-2-2ZM15.01 21.47l-1.92-1.92a.9.9 0 0 0-1.27 0 .9.9 0 0 0 0 1.27l2.47 2.47c.39.39 1.02.39 1.41 0l5.85-5.85a.9.9 0 0 0 0-1.27.9.9 0 0 0-1.27 0l-5.27 5.3Z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "phone-check_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M8 8h24v24H8z"
})))));
export default SvgPhoneCheck;